// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Trash = function Trash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.168 1.875h3.66a.31.31 0 0 1 .262.14l.742 1.11H7.168l.742-1.11a.32.32 0 0 1 .262-.14zm6.918 1.25L13.652.973A2.2 2.2 0 0 0 11.832 0H8.168c-.73 0-1.414.367-1.82.973L4.914 3.125H2.188a.935.935 0 0 0-.938.938c0 .519.418.937.938.937h.453l.937 12.684A2.5 2.5 0 0 0 6.07 20h7.856a2.5 2.5 0 0 0 2.492-2.316L17.359 5h.453c.52 0 .938-.418.938-.937a.935.935 0 0 0-.937-.938h-2.727M15.48 5l-.93 12.547a.624.624 0 0 1-.624.578H6.07a.63.63 0 0 1-.625-.578L4.52 5z"
  }));
};
